import { render, staticRenderFns } from "./DoctorLogin.vue?vue&type=template&id=57cdd924&scoped=true"
import script from "./DoctorLogin.vue?vue&type=script&lang=js"
export * from "./DoctorLogin.vue?vue&type=script&lang=js"
import style0 from "./DoctorLogin.vue?vue&type=style&index=0&id=57cdd924&prod&scoped=true&lang=css"
import style1 from "./DoctorLogin.vue?vue&type=style&index=1&id=57cdd924&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cdd924",
  null
  
)

export default component.exports